export const ANNOUNCEMENTS_TYPE = {
  ALL: 'all',
  ROW: 'row',
  CATEGORY: 'category',
  SECTOR: 'sector',
};

export const SORT_ON = {
  DESC: 'desc',
  ASC: 'asc',
};
